import React from 'react'

const Layout = React.lazy(() => import('./Layout'))
const DefaultPage = React.lazy(() => import('./DefaultPage'))

export default {
  path: '/:channel/sleep-journal',
  name: 'Sleep journal',
  component: Layout,
  protected: true,
  childRoutes: [
    {path: 'default-page', name: 'Default page', component: DefaultPage, isIndex: true},
  ],
};



// WEBPACK FOOTER //
// ./src/features/sleep-journal/route.js